const faqs = [
    { 
        id: 1, 
        heading: 'What types of services do you offer?',
        content: 'We specialize in residential and commercial construction, including general contracting, structural engineering & project management.',
    },
    {
        id: 2,
        heading: 'How long does a construction project take?',
        content: 'The timeline varies based on project size. Residential projects may take a few months, while commercial buildings can take a year.',
    },
    { 
        id: 3,
        heading: 'How do you estimate the cost of a project?',
        content: 'Our team conducts a detailed assessment of materials, labor, & design elements to provide an accurate cost estimate before starting the project.',
    },
    {
        id: 4,
        heading: 'Do I need permits for my construction project?',
        content: 'Yes, most construction projects require permits. We handle all necessary permits and ensure compliance with local building codes and regulations.',
    },
    {
        id: 5,
        heading: 'Do you offer sustainable construction?',
        content: 'Absolutely! We use energy-efficient materials, green building techniques, and sustainable solutions to minimize environmental impact.',
    },
];

export default faqs;